<template>
  <div>
    <vs-row class="mb-4">
      <vs-col>
        <h5>
          <i class="dot"></i>증상조사표
        </h5>
      </vs-col>
    </vs-row>

    <!-- 1. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">1. 규칙적인(한번에 30분 이상, 1주일에 적어도 2-3회 이상) 여가 및 취미활동을 하고 계시는 곳에 표시하여 주십시오.</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-checkbox"><i><feather-icon v-if="form.input1 && form.input1.indexOf('게임 등 컴퓨터 관련 활동') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>게임 등 컴퓨터 관련 활동</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input1 && form.input1.indexOf('아노, 드럼펫 등 악기연주') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>아노, 드럼펫 등 악기연주</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input1 && form.input1.indexOf('뜨개질, 붓글씨 등') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>뜨개질, 붓글씨 등</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input1 && form.input1.indexOf('테니스, 축구, 농구, 골프 등 스포츠 활동') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>테니스, 축구, 농구, 골프 등 스포츠 활동</span>
          <span class="print-checkbox"><i><feather-icon v-if="form.input1 && form.input1.indexOf('해당사항 없음') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>해당사항 없음</span>
        </div>
        <div v-else class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <vs-checkbox class="mr-5" v-model="form.input1" vs-value="게임 등 컴퓨터 관련 활동" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input1', '해당사항 없음')">게임 등 컴퓨터 관련 활동</vs-checkbox>
          <vs-checkbox class="mr-5" v-model="form.input1" vs-value="아노, 드럼펫 등 악기연주" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input1', '해당사항 없음')">아노, 드럼펫 등 악기연주</vs-checkbox>
          <vs-checkbox class="mr-5" v-model="form.input1" vs-value="뜨개질, 붓글씨 등" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input1', '해당사항 없음')">뜨개질, 붓글씨 등</vs-checkbox>
          <vs-checkbox class="mr-5" v-model="form.input1" vs-value="테니스, 축구, 농구, 골프 등 스포츠 활동" color="secondary" :disabled="readonly" @change="handleRemoveDefault('input1', '해당사항 없음')">테니스, 축구, 농구, 골프 등 스포츠 활동</vs-checkbox>
          <vs-checkbox v-model="form.input1" vs-value="해당사항 없음" color="secondary" :disabled="readonly" @change="handleInitData('input1', '해당사항 없음')">해당사항 없음</vs-checkbox>
        </div>
      </vs-col>
    </vs-row>

    <!-- 2. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">2. 귀하의 하루 평균 가사노동시간(밥하기, 빨래하기, 청소하기, 2살 미만의 아이 돌보기 등)은 얼마나 됩니까?</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('거의 하지 않는다.') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>거의 하지 않는다.</span>
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('1시간 미만') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>1시간 미만</span>
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('1-2시간 미만') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>1-2시간 미만</span>
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('2-3시간 미만') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>2-3시간 미만</span>
          <span class="print-radio"><i><feather-icon v-if="form.input2 && form.input2.indexOf('3시간 이상') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>3시간 이상</span>
        </div>
        <div v-else class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <vs-radio class="ml-2 mr-5" v-model="form.input2" vs-value="거의 하지 않는다." color="secondary" :disabled="readonly">거의 하지 않는다.</vs-radio>
          <vs-radio class="mr-5" v-model="form.input2" vs-value="1시간 미만" color="secondary" :disabled="readonly">1시간 미만</vs-radio>
          <vs-radio class="mr-5" v-model="form.input2" vs-value="1-2시간 미만" color="secondary" :disabled="readonly">1-2시간 미만</vs-radio>
          <vs-radio class="mr-5" v-model="form.input2" vs-value="2-3시간 미만" color="secondary" :disabled="readonly">2-3시간 미만</vs-radio>
          <vs-radio v-model="form.input2" vs-value="3시간 이상" color="secondary" :disabled="readonly">3시간 이상</vs-radio>
        </div>
      </vs-col>
    </vs-row>

    <!-- 3. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">3. 귀하는 의사로부터 다음과 같은 질병에 대해 진단을 받은 적이 있습니까?(해당 질병에 체크)</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 grid" style="align-items: center;" >
          <div class="flex mb-4">
            <span class="print-radio"><i><feather-icon v-if="form.input3 && form.input3.indexOf('아니오') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>아니오</span>
            <span class="print-radio"><i><feather-icon v-if="form.input3 && form.input3.indexOf('예') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>예</span>
            <span v-if="form.input3 === '${hIdx}|예'" class="mr-5" style="color:#696D71; font-weight: 400;">* ‘예’인 경우 현재상태는 ?</span>
            <span v-if="form.input3 === '${hIdx}|예'" class="print-radio"><i><feather-icon v-if="form.input3_option1 && form.input3_option1.indexOf('완치') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>완치</span>
            <span v-if="form.input3 === '${hIdx}|예'" class="print-radio"><i><feather-icon v-if="form.input3_option1 && form.input3_option1.indexOf('치료나 관찰중') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>치료나 관찰중</span>
          </div>
          <div v-if="form.input3 === '${hIdx}|예'" class="flex">
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_option2 && form.input3_option2.indexOf('류머티스 관절염') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>류머티스 관절염</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_option2 && form.input3_option2.indexOf('당뇨병') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>당뇨병</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_option2 && form.input3_option2.indexOf('통풍') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>통풍</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_option2 && form.input3_option2.indexOf('알코올중독') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>알코올중독</span>
            <span class="print-checkbox"><i><feather-icon v-if="form.input3_option2 && form.input3_option2.indexOf('해당사항 없음') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>해당사항 없음</span>
          </div>
        </div>
        <div v-else class="w-full px-2 mb-4 grid" style="align-items: center;" >
          <div class="flex mb-4">
            <vs-radio class="ml-2 mr-5" v-model="form.input3" vs-value="${hIdx}|아니오" color="secondary" :disabled="readonly">아니오</vs-radio>
            <vs-radio class="mr-8" v-model="form.input3" vs-value="${hIdx}|예" color="secondary" :disabled="readonly">예</vs-radio>
            <span v-if="form.input3 === '${hIdx}|예'" class="mr-5" style="color:#696D71; font-weight: 400;">* ‘예’인 경우 현재상태는 ?</span>
            <vs-radio v-if="form.input3 === '${hIdx}|예'" class="mr-5" v-model="form.input3_option1" vs-value="완치" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)">완치</vs-radio>
            <vs-radio v-if="form.input3 === '${hIdx}|예'" class="mr-5" v-model="form.input3_option1" vs-value="치료나 관찰중" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)">치료나 관찰중</vs-radio>
          </div>
          <div v-if="form.input3 === '${hIdx}|예'" class="flex">
            <vs-checkbox class="mr-5" v-model="form.input3_option2" vs-value="류머티스 관절염" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)" @change="handleRemoveDefault('input3_option2', '해당사항 없음')">류머티스 관절염</vs-checkbox>
            <vs-checkbox class="mr-5" v-model="form.input3_option2" vs-value="당뇨병" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)" @change="handleRemoveDefault('input3_option2', '해당사항 없음')">당뇨병</vs-checkbox>
            <vs-checkbox class="mr-5" v-model="form.input3_option2" vs-value="통풍" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)" @change="handleRemoveDefault('input3_option2', '해당사항 없음')">통풍</vs-checkbox>
            <vs-checkbox class="mr-5" v-model="form.input3_option2" vs-value="알코올중독" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)" @change="handleRemoveDefault('input3_option2', '해당사항 없음')">알코올중독</vs-checkbox>
            <vs-checkbox v-model="form.input3_option2" vs-value="해당사항 없음" color="secondary" :disabled="(form.input3 !== '${hIdx}|예'||readonly)" @change="handleInitData('input3_option2', '해당사항 없음')">해당사항 없음</vs-checkbox>
          </div>
        </div>
      </vs-col>
    </vs-row>

    <!-- 4. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">4. 과거에 운동 중 혹은 사고(교통사고, 넘어짐, 추락 등)로 인해 손/손가락/손목, 팔/팔꿈치, 어깨, 목, 허리, 다리/발 부위를 다친 적인 있습니까 ?</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-radio"><i><feather-icon v-if="form.input4 && form.input4.indexOf('아니오') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>아니오</span>
          <span class="print-radio"><i><feather-icon v-if="form.input4 && form.input4.indexOf('예') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>예</span>
          <span v-if="form.input4 === '4|예'" class="mr-5" style="color:#696D71; font-weight: 400;">* ‘예’인 경우 상해 부위는 ?</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('손/손가락/손목') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>손/손가락/손목</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('팔/팔꿈치') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>팔/팔꿈치</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('어깨') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>어깨</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('목') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>목</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('허리') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>허리</span>
          <span v-if="form.input4 === '4|예'" class="print-checkbox"><i><feather-icon v-if="form.input4_option && form.input4_option.indexOf('다리/발') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>다리/발</span>
        </div>
        <div v-else class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <vs-radio class="ml-2 mr-5" v-model="form.input4" vs-value="4|아니오" color="secondary" :disabled="readonly">아니오</vs-radio>
          <vs-radio class="mr-8" v-model="form.input4" vs-value="4|예" color="secondary" :disabled="readonly">예</vs-radio>
          <span v-if="form.input4 === '4|예'" class="mr-5" style="color:#696D71; font-weight: 400;">* ‘예’인 경우 상해 부위는 ?</span>
          <vs-checkbox v-if="form.input4 === '4|예'" class="mr-5" v-model="form.input4_option" vs-value="손/손가락/손목" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">손/손가락/손목</vs-checkbox>
          <vs-checkbox v-if="form.input4 === '4|예'" class="mr-5" v-model="form.input4_option" vs-value="팔/팔꿈치" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">팔/팔꿈치</vs-checkbox>
          <vs-checkbox v-if="form.input4 === '4|예'" class="mr-5" v-model="form.input4_option" vs-value="어깨" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">어깨</vs-checkbox>
          <vs-checkbox v-if="form.input4 === '4|예'" class="mr-5" v-model="form.input4_option" vs-value="목" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">목</vs-checkbox>
          <vs-checkbox v-if="form.input4 === '4|예'" class="mr-5" v-model="form.input4_option" vs-value="허리" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">허리</vs-checkbox>
          <vs-checkbox v-if="form.input4 === '4|예'" class="mr-5" v-model="form.input4_option" vs-value="다리/발" color="secondary" :disabled="(form.input4 !== '4|예'||readonly)">다리/발</vs-checkbox>
        </div>
      </vs-col>
    </vs-row>
    <!-- 5. -->
    <div class="px-2 py-5" style="font-size:16px; font-weight: 500;">5. 현재 하시는 일의 육체적 부담 정도는 어느 정도라고 생각 합니까 ?</div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="print-radio"><i><feather-icon v-if="form.input5 && form.input5.indexOf('전혀 힘들지 않음') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>전혀 힘들지 않음</span>
          <span class="print-radio"><i><feather-icon v-if="form.input5 && form.input5.indexOf('견딜만 함') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>견딜만 함</span>
          <span class="print-radio"><i><feather-icon v-if="form.input5 && form.input5.indexOf('약간 힘듦') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>약간 힘듦</span>
          <span class="print-radio"><i><feather-icon v-if="form.input5 && form.input5.indexOf('힘듦') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>힘듦</span>
          <span class="print-radio"><i><feather-icon v-if="form.input5 && form.input5.indexOf('매우 힘듦') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>매우 힘듦</span>
        </div>
        <div v-else class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <vs-radio class="mr-5" v-model="form.input5" vs-value="전혀 힘들지 않음" color="secondary" :disabled="readonly">전혀 힘들지 않음</vs-radio>
          <vs-radio class="mr-5" v-model="form.input5" vs-value="견딜만 함" color="secondary" :disabled="readonly">견딜만 함</vs-radio>
          <vs-radio class="mr-5" v-model="form.input5" vs-value="약간 힘듦" color="secondary" :disabled="readonly">약간 힘듦</vs-radio>
          <vs-radio class="mr-5" v-model="form.input5" vs-value="힘듦" color="secondary" :disabled="readonly">힘듦</vs-radio>
          <vs-radio v-model="form.input5" vs-value="매우 힘듦" color="secondary" :disabled="readonly">매우 힘듦</vs-radio>
        </div>
      </vs-col>
    </vs-row>

    <div class="px-2 py-5 my-4" style="border-bottom: 1px solid #CDCDCD;  font-size:16px; font-weight: 500; page-break-before: always; ">
      II. 지난 1년 동안 손/손가락/손목, 팔/팔꿈치, 어깨, 목, 허리, 다리/발 중 어느 한 부위에서라도 귀하의 작업과 관련하여 통증이나 불편함(통증, 쑤시는 느낌, 뻣뻣함, 화끈거리는 느낌, 무감각 혹은 찌릿찌릿함 등)을 느끼신 적이 있습니까 ?
    </div>
    <vs-row>
      <vs-col class="grid" vs-align="center">
        <div v-if="isPrint" class="w-full px-2 mb-4 grid" style="align-items: center;" >
          <span class="print-radio mb-4"><i><feather-icon v-if="form.input6 && form.input6.indexOf('6|아니오') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>아니오(수고하셨습니다. 설문을 다 마치셨습니다.)</span>
          <span class="print-radio"><i><feather-icon v-if="form.input6 && form.input6.indexOf('6|예') === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>예(“예”라고 답하신 분은 아래 표의 통증부위에 체크하고, 해당 통증부위의 세로줄로 내려가며 해당사항에 체크해 주십시오)</span>
        </div>
        <div v-else class="w-full px-2 mb-4 grid" style="align-items: center;" >
          <vs-radio class="mr-5 mb-4" v-model="form.input6" vs-value="6|아니오" color="secondary" :disabled="readonly">아니오(수고하셨습니다. 설문을 다 마치셨습니다.)</vs-radio>
          <vs-radio class="mr-8" v-model="form.input6" vs-value="6|예" color="secondary" :disabled="readonly">예(“예”라고 답하신 분은 아래 표의 통증부위에 체크하고, 해당 통증부위의 세로줄로 내려가며 해당사항에 체크해 주십시오)</vs-radio>
        </div>

        <div v-if="isPrint && form.input6 === '6|예'" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="mr-5" style="color:#696D71; font-weight: 400;">* ‘예’인 경우 상해 부위는 ?</span>
          <span v-for="key in checkHeads" class="print-checkbox"><i><feather-icon v-if="form.input6_option1 && form.input6_option1.indexOf(key) >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>{{key}}</span>
        </div>
        <div v-else-if="form.input6 === '6|예'" class="w-full px-2 mb-4 flex" style="align-items: center;" >
          <span class="mr-5" style="color:#696D71; font-weight: 400;">* ‘예’인 경우 상해 부위는 ?</span>
          <vs-checkbox v-for="key in checkHeads" class="mr-5" v-model="form.input6_option1" :vs-value="key" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">{{key}}</vs-checkbox>
        </div>

        <div v-if="form.input6 === '6|예'" class="check-table">
          <vs-row >
            <vs-col>통증부위</vs-col>
            <vs-col>
              <div v-for="head in checkTableHeads" class="table-border">{{  head  }}</div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>1. 통증의 구체적 부위는?</vs-col>
            <vs-col>
              <div v-for="(head, hIdx) in checkTableHeads" class="table-border">
                <div v-if="head === '목' || head === '허리'">-</div>
                <div v-else-if="isPrint" >
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][0].indexOf(`${head}-${0}|오른쪽`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>오른쪽</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][0].indexOf(`${head}-${0}|왼쪽`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>왼쪽</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][0].indexOf(`${head}-${0}|양쪽 모두`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>양쪽 모두</span>
                </div>
                <div v-else>
                  <vs-radio v-model="form.input6_option2[head][0]" :vs-value="`${head}-${0}|오른쪽`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">오른쪽</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][0]" :vs-value="`${head}-${0}|왼쪽`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">왼쪽</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][0]" :vs-value="`${head}-${0}|양쪽 모두`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">양쪽 모두</vs-radio>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>2. 한번 아프기 시작하면 통증 기간은 얼마 동안 지속됩니까?</vs-col>
            <vs-col>
              <div v-for="(head, hIdx) in checkTableHeads" class="table-border">
                <div v-if="isPrint">
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][1].indexOf(`${head}-${1}|1일 미만`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>1일 미만</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][1].indexOf(`${head}-${1}|1일 - 1주일 미만`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>1일 - 1주일 미만</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][1].indexOf(`${head}-${1}|1주일 - 1달 미만`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>1주일 - 1달 미만</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][1].indexOf(`${head}-${1}|1달 - 6개월 미만`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>1달 - 6개월 미만</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][1].indexOf(`${head}-${1}|6개월 이상`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>6개월 이상</span>
                </div>
                <div v-else >
                  <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1일 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">1일 미만</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1일 - 1주일 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">1일 - 1주일 미만</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1주일 - 1달 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">1주일 - 1달 미만</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|1달 - 6개월 미만`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">1달 - 6개월 미만</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][1]" :vs-value="`${head}-${1}|6개월 이상`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">6개월 이상</vs-radio>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col class="flex flex-col">
              3. 그때의 아픈 정도는 어느 정도 입니까 ?
              <div class="flex w-full p-0" style="color:#7E72F2; justify-content: start">
                <vx-tooltip
                  v-if="!isPrint"
                  title="통증 기준표?"
                  :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'"
                  style="
                    cursor: pointer;
                    margin-left: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                  position="top"
                  delay=".1s"
                >
                  <feather-icon
                    icon="AlertCircleIcon"
                    style="
                      width: 18px;
                      color: #7e72f2;
                      margin-right: 3px;
                    "
                    @click="onClickToolTip()"
                  />
                  <span @click="onClickToolTip()">통증 기준표</span>
                </vx-tooltip>
              </div>
            </vs-col>
            <vs-col>
              <div v-for="(head, hIdx) in checkTableHeads" class="table-border">
                <div v-if="isPrint">
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][2].indexOf(`${head}-${2}|약한 통증`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>약한 통증</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][2].indexOf(`${head}-${2}|중간 통증`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>중간 통증</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][2].indexOf(`${head}-${2}|심한 통증`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>심한 통증</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][2].indexOf(`${head}-${2}|매우 심한 통증`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>매우 심한 통증</span>
                </div>
                <div v-else>
                  <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|약한 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">약한 통증</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|중간 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">중간 통증</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|심한 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">심한 통증</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][2]" :vs-value="`${head}-${2}|매우 심한 통증`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">매우 심한 통증</vs-radio>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>4. 지난 1년 동안 이러한 증상을 얼마나 자주 경험하셨습니까 ?</vs-col>
            <vs-col>
              <div v-for="(head, hIdx) in checkTableHeads" class="table-border">
                <div v-if="isPrint">
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][3].indexOf(`${head}-${3}|6개월에 1번`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>6개월에 1번</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][3].indexOf(`${head}-${3}|2-3달에 1번`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>2-3달에 1번</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][3].indexOf(`${head}-${3}|1달에 1번`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>1달에 1번</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][3].indexOf(`${head}-${3}|1주일에 1번`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>1주일에 1번</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][3].indexOf(`${head}-${3}|매일`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>매일</span>
                </div>
                <div v-else>
                  <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|6개월에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">6개월에 1번</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|2-3달에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">2-3달에 1번</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|1달에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">1달에 1번</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|1주일에 1번`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">1주일에 1번</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][3]" :vs-value="`${head}-${3}|매일`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">매일</vs-radio>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>5. 지난 1주일 동안에도 이러한 증상이 있었습니까 ?</vs-col>
            <vs-col>
              <div v-for="(head, hIdx) in checkTableHeads" class="table-border">
                <div v-if="isPrint">
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][4].indexOf(`${head}-${4}|아니요`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>아니요</span>
                  <span class="print-radio"><i><feather-icon v-if="form.input6_option2[head][4].indexOf(`${head}-${4}|예`) === 0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>예</span>
                </div>
                <div v-else>
                  <vs-radio v-model="form.input6_option2[head][4]" :vs-value="`${head}-${4}|아니요`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">아니요</vs-radio>
                  <vs-radio v-model="form.input6_option2[head][4]" :vs-value="`${head}-${4}|예`" color="secondary" :disabled="(form.input6 !== '6|예'||readonly)">예</vs-radio>
                </div>
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col>6. 지난 1년 동안 이러한 통증으로 인해 어떤 일이 있었습니까 ?</vs-col>
            <vs-col>
              <div v-for="(head, hIdx) in checkTableHeads" class="table-border">
                <div v-if="isPrint">
                  <span class="print-checkbox"><i><feather-icon v-if="form.input6_option2 && form.input6_option2[head][5].indexOf('병원․한의원 치료') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>병원․한의원 치료</span>
                  <span class="print-checkbox"><i><feather-icon v-if="form.input6_option2 && form.input6_option2[head][5].indexOf('약국치료') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>약국치료</span>
                  <span class="print-checkbox"><i><feather-icon v-if="form.input6_option2 && form.input6_option2[head][5].indexOf('병가, 산재') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>병가, 산재</span>
                  <span class="print-checkbox"><i><feather-icon v-if="form.input6_option2 && form.input6_option2[head][5].indexOf('작업 전환') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>작업 전환</span>
                  <span class="print-checkbox"><i><feather-icon v-if="form.input6_option2 && form.input6_option2[head][5].indexOf('해당사항 없음') >=0 " svgClasses="w-4 w-5" icon="CheckIcon" /></i>해당사항 없음</span>
                  <span class="print-input">{{form.input6_option2[head][6]}}</span>
                </div>
                <div v-else>
                  <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="병원․한의원 치료" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">병원․한의원 치료</vs-checkbox>
                  <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="약국치료" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">약국치료</vs-checkbox>
                  <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="병가, 산재" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">병가, 산재</vs-checkbox>
                  <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="작업 전환" color="secondary" :disabled="readonly" @change="handleRemoveDefaultWithCheckTable(head, 5, '해당사항 없음')">작업 전환</vs-checkbox>
                  <vs-checkbox v-model="form.input6_option2[head][5]" vs-value="해당사항 없음" color="secondary" :disabled="readonly" @change="handleInitDataWithCheckTable(head, 5, '해당사항 없음')">해당사항 없음</vs-checkbox>
                  <ml-input class="w-full" v-model="form.input6_option2[head][6]" :readonly="(form.input6_option2[head][5][0] !== '해당사항 없음' || form.input6 !== '6|예'||readonly)"/>
                </div>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>

    <popup-alert v-model="alert.show"
                 :title="alert.title"
                 :html="alert.html"
                 :buttons="alert.buttons"
    ></popup-alert>
  </div>
</template>

<script>
import PopupAlert from '@/popup/PopupAlert'
export default {
  name: 'SymptomInvestigationTable',
  components: {PopupAlert},
  props: {
    isPrint: Boolean,
    value: Object,
    readonly: Boolean,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler() {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }

        this.$emit("input", this.form);
      },
    },
  },
  computed: {
    checkHeads () {
      return Object.keys(this.form.input6_option2)
    },
    checkTableHeads () {
      const keys = Object.keys(this.form.input6_option2)
      const heads = []

      for (const key of keys) {
        if (this.form.input6_option1 && this.form.input6_option1.indexOf(key) >= 0) {
          heads.push(key)
        }
      }
      return heads
    },
  },
  data () {
    return {
      alert: {
        show: false,
        title: '통증 기준표',
        html:
          '<div style="width: 540px; padding: 24px;">' +
            '<p style="font-size: 16px;"><b>약한 통증 : </b>약간 불편한 정도이나 작업에 열중할 때는 못 느낀다</p>' +
            '<p style="font-size: 16px;"><b>중간 통증 : </b>작업 중 통증이 있으나 귀가 후 휴식을 취하면 괜찮다</p>' +
            '<p style="font-size: 16px;"><b>심한 통증 : </b>작업 중 통증이 비교적 심하고 귀가 후에도 통증이 계속된다</p>' +
            '<p style="font-size: 16px;"><b>매우 심한 통증 : </b>통증 때문에 작업은 물론 일상생활을 하기가 어렵다</p>'+
          '</div>'
        ,
        buttons: []
      },
      form: {
        input1: ['해당사항 없음'],
        input2: {},
        input3: '',
        input3_option1: '',
        input3_option2: ['해당사항 없음'],
        input4: '',
        input4_option: [],
        input5: '',
        input6: '',
        input6_option1: [],
        input6_option2: {
          '목': ['', '', '', '', '', []],
          '어깨': ['', '', '', '', '', []],
          '손/손가락/손목': ['', '', '', '', '', []],
          '팔/팔꿈치': ['', '', '', '', '', []],
          '허리': ['', '', '', '', '', []],
          '다리/발': ['', '', '', '', '', []],
        }
      }
    }
  },
  methods: {
    onClickToolTip () {
      this.alert.show = true
    },

    handleInitData (key, str) {
      if (typeof this.form[key] === 'object') {
        if (this.form[key].length > 0) {
          this.form[key] = [str]
        }
      } else if (typeof this.form[key] === 'string') {
        if (this.form[key]) {
          this.form[key] = str
        }
      }
    },

    handleRemoveDefault (key, str) {
      if (typeof this.form[key] === 'object') {
        const index = this.form[key].indexOf(str)
        if (index === 0 && this.form[key].length == 2) {
          this.form[key] = this.form[key].removeIndex(index)
        }
      } else if (typeof this.form[key] === 'string') {
        //this.form[key] = str
      }
    },


    handleInitDataWithCheckTable (key1, key2, str) {
      if (this.form.input6_option2[key1][key2] && this.form.input6_option2[key1][key2].length > 0) {
        this.form.input6_option2[key1][key2] = [str]
      }
    },

    handleRemoveDefaultWithCheckTable (key1, key2, str) {
      const index = this.form.input6_option2[key1][key2].indexOf(str)
      if (index === 0 && this.form.input6_option2[key1][key2].length == 2) {
        this.form.input6_option2[key1][key2] = this.form.input6_option2[key1][key2].removeIndex(index)
        this.form.input6_option2[key1][6] = ''
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.check-table {
  border-top: 1px solid #CDCDCD;
  border-left: 1px solid #CDCDCD;
  & > .vs-row {
    display: grid !important;
    grid-template-columns: 165px 1fr;

    .vs-col {
      border-right: 1px solid #CDCDCD;
      border-bottom: 1px solid #CDCDCD;
    }
    .vs-col:first-child {
      width: 165px;
    }
    .vs-col:last-child {
      display: flex;

      & > div:first-child {

      }
      & > div {
        width: 100%;
        display: flex;
        justify-content: center;

        & > div {
          width: 100%;
          max-width: 165px;
          display: grid;
          grid-template-columns: 1fr;
          justify-content: center;
          align-items: center;
          gap: 0.875rem;

          text-align: center;
          & > .vs-radio { width: 100%;}
          .checkbox_x.vs-checkbox { min-width:20px; min-height: 20px;}
        }
      }
    }
  }

  .table-border{
    border-right: 1px solid #CDCDCD;
    &:last-child{
      border-right: 0;
    }
  }

  /* 배경색상 */
  & > .vs-row:first-child,
  & > .vs-row > div:first-child {
    background: #F9F9F9;
    color: #3C3C3C;
    font-weight: 500;
  }

  /* 패딩 */
  & > .vs-row > .vs-col > div,
  & > .vs-row > div:first-child {
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;
  margin-right: 1rem;

  & > i { width:20px; height: 20px; border:2px solid #cdcdcd; position: relative; margin-right: 6px; }
  & .feather-icon { transform: translateY(-4px); }
}

.print-radio {
  & > i { border-radius: 20px; }
}
</style>
